import SSocket from "servisofts-socket";

const config = {
    reducer: "paqueteReducer",
    component: "paquete"
}
export default class Actions {
   
}